// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.edit-role {
    display: flex;    
    justify-content: flex-start;
    align-items: center;
    
}

.edit-role__image{
    display: flex;
    align-items: center;
}

.edit-role__image .icon-ball {
    color: var( --white-color );
    font-size: 30px;
    border-radius: 50%;
    padding: 5px;  
}

.edit-role__image img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.edit-role__data {
    align-items: center;
    margin-left: 8px;
}

.edit-role__data .baloa-names{
    color: var(8--primary-very-dark-color);
}

.edit-role__data .baloa-username {
    color: var(--primary-dark-color);
}

.edit-role .MuiInput-underline:hover:not(.Mui-disabled):before, .edit-role .MuiInput-underline:before{
    border-bottom: none;
}

.edit-role .MuiSelect-select:focus{
    background-color: unset;
}

.edit-role .select-field-input{
    background-color: var(--white-color);
    border-radius: 4px;
    

}
.edit-role .select-field-input .baloa-table{
    color: var(--primary-dark-color);
}

.edit-role .MuiTypography-body1, .edit-role__menu .MuiTypography-body1{
    color: var(--primary-very-dark-color);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    letter-spacing: 0.0025em;
}

.edit-role .MuiTypography-body2, .edit-role__menu .MuiTypography-body2{
    color: var(--primary-dark-color);
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.0025em;
}

.edit-role__menu .MuiListItem-button:hover{
    background-color: var(--new-background-color);
}`, "",{"version":3,"sources":["webpack://./src/shared/components/dynamic-table/EditRoleComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;;;AAGtB;AACA;IACI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,6CAA6C;AACjD","sourcesContent":[".edit-role {\n    display: flex;    \n    justify-content: flex-start;\n    align-items: center;\n    \n}\n\n.edit-role__image{\n    display: flex;\n    align-items: center;\n}\n\n.edit-role__image .icon-ball {\n    color: var( --white-color );\n    font-size: 30px;\n    border-radius: 50%;\n    padding: 5px;  \n}\n\n.edit-role__image img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.edit-role__data {\n    align-items: center;\n    margin-left: 8px;\n}\n\n.edit-role__data .baloa-names{\n    color: var(8--primary-very-dark-color);\n}\n\n.edit-role__data .baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.edit-role .MuiInput-underline:hover:not(.Mui-disabled):before, .edit-role .MuiInput-underline:before{\n    border-bottom: none;\n}\n\n.edit-role .MuiSelect-select:focus{\n    background-color: unset;\n}\n\n.edit-role .select-field-input{\n    background-color: var(--white-color);\n    border-radius: 4px;\n    \n\n}\n.edit-role .select-field-input .baloa-table{\n    color: var(--primary-dark-color);\n}\n\n.edit-role .MuiTypography-body1, .edit-role__menu .MuiTypography-body1{\n    color: var(--primary-very-dark-color);\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 18px;\n    letter-spacing: 0.0025em;\n}\n\n.edit-role .MuiTypography-body2, .edit-role__menu .MuiTypography-body2{\n    color: var(--primary-dark-color);\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 13px;\n    line-height: 15px;\n    letter-spacing: 0.0025em;\n}\n\n.edit-role__menu .MuiListItem-button:hover{\n    background-color: var(--new-background-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
